import AdminLayout from '@/layouts/AdminLayout.vue'

const IMPORT_EXPORT_PERMISSIONS = [
  'ADMIN_EXTRACT_PRODUCT_REFERENTIAL',
  'ADMIN_IMPORT_PRODUCT_REFERENTIAL',
  'ADMIN_EXTRACT_PACKAGE_REFERENTIAL',
  'ADMIN_IMPORT_PACKAGE_REFERENTIAL',
  'ADMIN_EXTRACT_SERIAL_NUMBER_REFERENTIAL',
  'ADMIN_IMPORT_SERIAL_NUMBER_REFERENTIAL',
  'ADMIN_EXTRACT_GUARANTEE_EXTENSION_REFERENTIAL',
  'ADMIN_IMPORT_GUARANTEE_EXTENSION_REFERENTIAL',
  'ADMIN_EXTRACT_GUARANTEE_REFERENTIAL',
  'ADMIN_IMPORT_GUARANTEE_REFERENTIAL',
  'ADMIN_EXTRACT_PRODUCT_BREAKDOWN_REFERENTIAL',
  'ADMIN_IMPORT_PRODUCT_BREAKDOWN_REFERENTIAL',
  'ADMIN_EXTRACT_PRODUCT_DISTRIBUTOR_REF_REFERENTIAL',
  'ADMIN_IMPORT_PRODUCT_DISTRIBUTOR_REF_REFERENTIAL',
  'ADMIN_EXTRACT_PRODUCT_STORE_PRICE_REFERENTIAL',
  'ADMIN_IMPORT_PRODUCT_STORE_PRICE_REFERENTIAL',
  'ADMIN_EXTRACT_TRANSPORT_PACKAGE_REFERENTIAL',
  'ADMIN_IMPORT_TRANSPORT_PACKAGE_REFERENTIAL',
  'ADMIN_EXTRACT_TRANSPORTER_REFERENTIAL',
  'ADMIN_IMPORT_TRANSPORTER_REFERENTIAL',
  'ADMIN_EXTRACT_ESTIMATE_TRANSPORTER_COST_REFERENTIAL',
  'ADMIN_IMPORT_ESTIMATE_TRANSPORTER_COST_REFERENTIAL',
  'ADMIN_EXTRACT_ADDITIONAL_REPAIR_COST_REFERENTIAL',
  'ADMIN_IMPORT_ADDITIONAL_REPAIR_COST_REFERENTIAL',
  'ADMIN_EXTRACT_RECYCLER_BAC_REFERENTIAL',
  'ADMIN_IMPORT_RECYCLER_BAC_REFERENTIAL',
  'ADMIN_EXTRACT_RECYCLING_BUYBACK_REFERENTIAL',
  'ADMIN_IMPORT_RECYCLING_BUYBACK_REFERENTIAL',
  'ADMIN_EXTRACT_RECYCLING_CLIENT_LINK_REFERENTIAL',
  'ADMIN_IMPORT_RECYCLING_CLIENT_LINK_REFERENTIAL',
  'ADMIN_EXTRACT_RENTAL_PRODUCT_REFERENTIAL',
  'ADMIN_IMPORT_RENTAL_PRODUCT_REFERENTIAL',
  'ADMIN_EXTRACT_KEY_ACCOUNT_PRODUCT_REFERENTIAL',
  'ADMIN_KEY_ACCOUNT_PRODUCT_IMPORT_PERMISSION'
]

export default [
  {
    path: '/import-export',
    name: 'importExport',
    component: () => import('@/views/restricted/import-export/ImportExportView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: IMPORT_EXPORT_PERMISSIONS,
      menuSelected: 'import-export'
    }
  }
]
